import { render } from "./ProductFilters.vue?vue&type=template&id=b0b3e9e2"
import script from "./ProductFilters.vue?vue&type=script&lang=js"
export * from "./ProductFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__